import { render, staticRenderFns } from "./NavigationContainer.vue?vue&type=template&id=ba74c432"
import script from "./NavigationContainer.vue?vue&type=script&lang=js"
export * from "./NavigationContainer.vue?vue&type=script&lang=js"
import style0 from "./NavigationContainer.vue?vue&type=style&index=0&id=ba74c432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports